import { useMemo } from 'react';

import { useTimeseriesFilteredData } from './useTimeseriesFilteredData.js';
import { AxesUnits } from '../types/timeseries.js';

export const useTimeseriesUnits = (): AxesUnits => {
  const { units } = useTimeseriesFilteredData();

  return useMemo(() => [...new Set(units)].slice(0, 2) as AxesUnits, [units]);
};
